import { Inject, Injectable, Optional } from '@angular/core';
import { IFRAME_BRIDGE_REGISTRAR } from './iframe-bridge-dialog.service';

/**
 * Eagerly constructs all iframe-bridge feature services registered under
 * the IFRAME_BRIDGE_REGISTRAR multi-token.
 *
 * Each feature service self-registers its dialog handlers by injecting
 * IframeBridgeDialogService and calling register() in its own constructor.
 * Injecting this initializer (in AppComponent) guarantees all of them are
 * instantiated at app startup, regardless of which route is active.
 *
 * Adding a new bridge feature service:
 *   1. Create the service (injects IframeBridgeDialogService, calls register()).
 *   2. In ServicesModule.forRoot() providers add:
 *        MyFeatureService,
 *        { provide: IFRAME_BRIDGE_REGISTRAR, useExisting: MyFeatureService, multi: true }
 *   AppComponent and this file do NOT need to change.
 */
@Injectable()
export class BridgeServicesInitializerService {
  constructor(
    // Injecting the multi-token forces Angular to construct each registered
    // feature service. We don't call anything on them here — construction
    // itself triggers their register() calls via their own constructors.
    @Optional() @Inject(IFRAME_BRIDGE_REGISTRAR) _services: unknown[] | null,
  ) {}
}
